function AvailabilityRuleOccurrenceMeedyVO(id, availabilityRule, availabilityRuleDayDefinition, resource,
                                         startTime, endTime, advanced, date, stationary, audioConsultation, videoConsultation,
                                         tripCity, tripCity30km, nightCity, nightCity30km, availableForInsuranceCompanies,
                                         availableForIcr, availableForPatients, availableForNfz) {

    this.id = id;
    this.availabilityRule = availabilityRule;
    this.availabilityRuleDayDefinition = availabilityRuleDayDefinition;
    this.resource = resource;
    this.startTime = startTime;
    this.endTime = endTime;
    this.date = date;
    this.advanced = advanced;
    this.stationary = stationary;
    this.audioConsultation = audioConsultation;
    this.videoConsultation = videoConsultation;
    this.tripCity = tripCity;
    this.nightCity = nightCity;
    this.tripCity30km = tripCity30km;
    this.nightCity30km = nightCity30km;
    this.availableForInsuranceCompanies = availableForInsuranceCompanies;
    this.availableForIcr = availableForIcr;
    this.availableForPatients = availableForPatients;
    this.availableForNfz = availableForNfz;


    var _typeContext = {
        availabilityRule: AvailabilityRuleMeedyVO,
        startTime: Date,
        endTime : Date,
        resource : ResourceMeedyVO,
        availabilityRuleDayDefinition : AvailabilityRuleDayDefinitionMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
